<template>
    <div class="booking">
        <LoginHeader />
        <b-card class="mx-5 mt-5">
            <b-row class="mb-5 mx-0 mx-md-5 mt-3">
                <b-col md="6" cols="12">
                    <b-button class="roundeds" @click="tab = 1" :variant="tab == 1 ? 'success':'outline-success'" block size="lg">1. {{ $t('select_lesson') }}</b-button>
                </b-col>
                <b-col md="6" cols="12" class="mt-md-0 mt-2">
                    <b-button class="roundeds" @click="tab = 2" :variant="tab == 2 ? 'success':'outline-success'" size="lg" block :disabled="tab == 1">2. {{$t('payment')}}</b-button>
                </b-col>

                <b-col cols="12" v-if="tab === 1">
                    <b-row class="mt-5">
                        <b-col md="3" lg="2" class="text-left" cols="12">
                            <h6><b>{{$t('select_course')}}</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <multiselect :placeholder="$t('select_course')" v-model="selectedCourse" class="roundeds" :options="getCourses" :tagabled="true" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :tag-placeholder="$t('select_course')" :label="($i18n.locale  === 'zh') ? 'chineseName' : 'name'" track-by="name" :preselect-first="false" />
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="selectedCourse && !selectedCourse.Lessons.length">
                        <b-col cols="12" class="text-center">
                            <strong>{{ $t('no_lesson_found') }} <span class="text-green">"{{($i18n.locale  === 'zh') ? selectedCourse.chineseName : selectedCourse.name}}"</span></strong>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="selectedCourse && selectedCourse.Lessons.length">
                        <b-col md="3" lg="2" class="text-left" cols="12">
                            <h6><b>{{ $t('select_lesson') }}</b></h6>
                        </b-col>
                        <b-col md="9" cols="12" v-if="selectedLesson">
                            <strong class="text-green">{{ ($i18n.locale  === 'zh') ? selectedCourse.chineseName : selectedCourse.name }}</strong>
                            <!-- <multiselect :placeholder="$t('select_lesson')" v-model="selectedLesson" class="roundeds" :options="selectedCourse.Lessons" :tagabled="true" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :tag-placeholder="$t('select_lesson')" label="name" track-by="name" :preselect-first="false" /> -->
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="selectedCourse && selectedLesson">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('class_size')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6>{{selectedLesson.availableSeats}}</h6>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="selectedCourse && selectedLesson">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('class_start_time')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6>{{ getDate(selectedLesson.startDate) }} - {{ selectedLesson.startTime }}</h6>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="selectedCourse && selectedLesson">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('class_end_time')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6>{{ getDate(selectedLesson.endDate) }} - {{ selectedLesson.endTime }}</h6>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="selectedCourse && selectedLesson">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('public_note')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 v-html="getPublicNote()"></h6>
                        </b-col>
                    </b-row>

                     <!-- Calender Start Here -->

                    <b-row class="mt-3 calendar-area" v-if="selectedCourse && selectedCourse.Lessons.length">
                        <b-col cols="12" lg="8" offset-lg="2">
                            <FullCalendar :options="calendarOptions" ref="calendar"/>
                        </b-col>
                        <b-col cols="12" lg="2">

                        </b-col>
                    </b-row>
                    
                    <!-- Calender End Here -->

                    <b-row class="mt-3" v-if="this.$route.query.type === 'member' && selectedCourse && selectedLesson">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('remarks')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <b-textarea rows="3" :placeholder="$t('remarks')" v-model="booking.remarks" required></b-textarea>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="this.$route.query.type==='corporate' && selectedCourse && selectedLesson">
                        <b-col class="text-left" md="3" cols="12">
                            <b>{{ $t('upload_attendees') }} <br> ({{$t('excel_file')}}) </b> <br>
                            <span class="text-green link" @click="sampleDownload"><i class="fa fa-download"></i> {{$t('download_sample_file')}}</span>
                        </b-col>
                        <b-col md="7" cols="12" class="mb-3">
                            <div v-cloak @drop.prevent="onUploadFiles" @dragover.prevent @click="pickFiles" class="text-center pick-file-area">
                                <p>
                                    <i class="fa fa-upload fa-2x"></i>
                                    <br />
                                </p>
                                <strong>{{ $t('click_or_drag') }}</strong>
                                <input
                                    type="file"
                                    style="display:none"
                                    ref="filesUpload"
                                    @change="onUploadFiles"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                />
                            </div>
                            <i class="fa fa-info-circle text-green"> {{$t('excel_only')}}</i>
                            <div v-if="file" class="">
                                <strong>{{file.name}}</strong>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="12" v-if="tab === 2 && selectedCourse && selectedLesson">
                    <b-row class="mt-5">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('course_name')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">{{ ($i18n.locale  === 'zh') ? selectedCourse.chineseName : selectedCourse.name }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('lesson_name')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">{{ selectedLesson.name }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('address')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">{{ ($i18n.locale  === 'zh') ? selectedLesson.addressChinese : selectedLesson.address }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('date_and_time')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 v-if="selectedLesson.startDate == selectedLesson.endDate" class="text-grey">{{ getDate(selectedLesson.startDate) }} {{ selectedLesson.startTime.split(':').slice(0,2).join(':') }} - {{ selectedLesson.endTime.split(':').slice(0,2).join(':') }}</h6>
                            <h6 v-else class="text-grey">{{ getDate(selectedLesson.startDate) }} {{ selectedLesson.startTime.split(':').slice(0,2).join(':') }} - {{ getDate(selectedLesson.endDate) }} {{ selectedLesson.endTime.split(':').slice(0,2).join(':') }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('public_note')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 v-html="getPublicNote()" class="text-grey"></h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{ $t('booking_type') }}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">{{this.$route.query.type === 'member' ? 'Individual' : 'Corporate'}}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('no_of_students')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">{{ this.$route.query.type === 'member' ? '1' : getMemberCount ? getMemberCount : '' }}</h6>
                        </b-col>
                    </b-row>
                    <b-row v-if="this.$route.query.type === 'member'" class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('remarks')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">{{ booking.remarks }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('lesson_fee')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey">HKD {{ selectedCourse.price }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('discount')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <h6 class="text-grey"> <span class="text-uppercase">{{ getDiscountType() }}</span> HKD {{ getDiscount() }}</h6>
                        </b-col>
                    </b-row>
                    <hr>
                    <div v-if="booking.paymentMethod == 'credit card'">
                        <b-row class="mt-3">
                            <b-col md="3" lg="2" cols="12" class="text-left">
                                <h6><b>{{$t('transaction_fee')}}:</b></h6>
                            </b-col>
                            <b-col md="9" cols="12">
                                <h6 class="text-grey">HKD {{ (getTotalPriceForStripe() - getTotalPrice()).toFixed(2) }}</h6>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col md="3" lg="2" cols="12" class="text-left">
                                <h6><b>{{$t('total_amount')}}:</b></h6>
                            </b-col>
                            <b-col md="9" cols="12">
                                <h6 class="text-grey">HKD {{ getTotalPriceForStripe() }}</h6>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else-if="booking.paymentMethod == 'AliPay'">
                        <b-row class="mt-3">
                            <b-col md="3" lg="2" cols="12" class="text-left">
                                <h6><b>{{$t('transaction_fee')}}:</b></h6>
                            </b-col>
                            <b-col md="9" cols="12">
                                <h6 class="text-grey">HKD {{ (getTotalPriceForAlipay() - getTotalPrice()).toFixed(2) }}</h6>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col md="3" lg="2" cols="12" class="text-left">
                                <h6><b>{{$t('total_amount')}}:</b></h6>
                            </b-col>
                            <b-col md="9" cols="12">
                                <h6 class="text-grey">HKD {{ getTotalPriceForAlipay() }}</h6>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <b-row class="mt-3">
                            <b-col md="3" lg="2" cols="12" class="text-left">
                                <h6><b>{{$t('total_amount')}}:</b></h6>
                            </b-col>
                            <b-col md="9" cols="12">
                                <h6 class="text-grey">HKD {{ getTotalPrice() }}</h6>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row class="mt-3">
                        <b-col md="3" lg="2" cols="12" class="text-left">
                            <h6><b>{{$t('payment_method')}}:</b></h6>
                        </b-col>
                        <b-col md="9" cols="12">
                            <b-form-select v-model="booking.paymentMethod" style="maxWidth: 250px;" class="roundeds" v-if="$route.query.type === 'member'">
                                <b-form-select-option :value="null">{{$t('select_payment_method')}}</b-form-select-option>
                                <b-form-select-option value="offline">{{ $t('otherPaymentMethod') }}</b-form-select-option>
                                <!-- <b-form-select-option value="AliPay">{{ $t('alipay') }}</b-form-select-option> -->
                                <b-form-select-option value="credit card">{{ $t('credit_card') }}</b-form-select-option>
                            </b-form-select>
                            <div v-if="$route.query.type === 'member' && booking.paymentMethod === 'credit card'">
                                <div class="mt-3">
                                    <stripe-element-card
                                    ref="elementRef"
                                    :pk="publishableKey"
                                    @token="tokenCreated"
                                    @error="bookingLoading=false"
                                    />
                                </div>
                                <span class="stripe-reminder">{{$t('stripe_reminder')}}</span>
                            </div>
                            <h6 v-if="$route.query.type === 'corporate'" class="text-grey">{{ $t('future_settlement') }}</h6>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col cols="12" class="text-left">
                            <span class="payment-reminder" v-html="$t('payment_reminder')"></span>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row class="mt-3">
                        <b-col cols="12" class="text-left">
                            <b-form-checkbox button-variant="success" v-model="acceptTerms"><span class="text-green link" @click="termsModal = !termsModal">{{ $t('read_terms') }}</span></b-form-checkbox>
                        </b-col>
                        <b-col cols="12" lg="6" v-if="$route.query.type === 'member'">
                            <b-form-checkbox v-model="no_promotions" class="mt-3" button-variant="success">
                                <span class="text-grey">{{ $t('no_promotions') }}</span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="12" class="mt-5">
                    <div v-if="tab === 1 && this.$route.query.type === 'corporate'">
                        <b-button v-if="selectedCourse && selectedLesson && file" variant="success" :disabled="nextLoading" class="roundeds px-5 py-2" @click="moveNext" >{{$t('next')}}</b-button>
                    </div>
                    <div v-if="tab === 1 && this.$route.query.type === 'member'">
                        <b-button v-if="selectedCourse && selectedLesson" variant="success" :disabled="nextLoading" class="roundeds px-5 py-2" @click="moveNext" >{{$t('next')}}</b-button>
                    </div>
                    <div v-if="tab === 2">
                        <b-button variant="success" class="roundeds px-5 py-2" @click="confirmBooking" :disabled="bookingLoading">{{ bookingLoading ? $t('confirming_booking') : $t('confirm_booking') }}</b-button> <br>
                        <b-button variant="outline-secondary" class="roundeds px-5 py-2 mt-2" @click="tab = 1" :disabled="bookingLoading">{{$t('go_back')}}</b-button>
                    </div>
                </b-col>
            </b-row>

        </b-card>

        <b-modal :title="$t('terms_and_conditions_header')" v-model="termsModal" content-class="tc-modal" hide-footer>
            <b-row>
                <b-col cols="12">
                    <div class="tc-modal-padding">
                        <ul>
                            <li v-for="(paragraph, index) in $t('terms_and_conditions_intro')" class="">
                                <p v-html="paragraph">{{paragraph}}</p>
                            </li>
                        </ul>
                        <ol>
                            <li v-for="(point, index) in $t('terms_and_conditions')" class="">
                                <p v-html="point.title"></p>
                                <ul>
                                    <li v-for="(paragraph, index) in point.content" class="">
                                        <p v-html="paragraph"></p>
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
import LoginHeader from '@/components/LoginHeader'
// import { FullCalendar } from 'vue-full-calendar'
// import 'fullcalendar/dist/fullcalendar.css'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import { StripeElementCard  } from '@vue-stripe/vue-stripe';
import config from '../../config.js'
export default {
    name: "Booking",
    components: {
        LoginHeader,
        FullCalendar,
        StripeElementCard
    },
    computed: {
        ...mapGetters(['getCourses', 'getMemberCount', 'getCorporate', 'getRedirectUrl', 'getTransactionId', 'getPaymentStatus'])
    },
    watch: {
        getCourses(val) {
            if(val) {
                this.setCourse()
            }
        },
        selectedCourse() {
            this.setCalendar()
        },
        // selectedLesson(val) {
        //     this.booking.lessonId = this.selectedLesson.id
        // }
    },
    mounted() {
        const type = this.getLoggedUser().type
        
        if(this.$route.fullPath !== `/booking?type=${type}`) {
            this.$router.replace({path: '/booking', query: {type: type}})
        }

        if(this.getCourse()) {
            this.$router.replace({path: '/booking', query: {type: type, course: this.getCourse()}})
        }
        
        if(!this.getCourses || this.getCourses.length < 1) {
            this.$store.dispatch('getCoursesWithEnrolledCount')
        } else {
            this.setCourse()
        }
    },
    data() {
        return {
            publishableKey: config.setting.stripePublishableKey,
            tab: 1,
            nextLoading: false,
            bookingLoading: false,
            file: null,
            payment: null,
            lessonsList: [],
            selectedCourse: null,
            selectedLesson: null,
            acceptTerms: false,
            no_promotions: false,
            termsModal: false,
            checkPaymentTimer: null,
            booking: {
                memberId: null,
                corporateId: null,
                lessonId: null,
                date: null,
                bookedAs: null,
                bookedBy: '',
                remarks: null,
                paymentMethod: null
            },
            bookingPayload: null,
            events: [],
            calendarOptions: {
                height: 500,
                plugins: [ dayGridPlugin, interactionPlugin ],
                selectable: true,
                initialView: 'dayGridMonth',
                validRange: {
                    start: this.getTodayDate(true)
                },
                eventDisplay: 'block',
                eventTimeFormat:{
                    hour: 'numeric',
                    meridiem: 'short'
                },
                eventClick: this.eventSelected,
                events: [],
            }
        }
    },
    methods: {
        setCourse() {
            if(this.$route.query.course) {
                if(this.getCourses && this.getCourses.length) {
                    this.selectedCourse = this.getCourses.find(course => course.id === this.$route.query.course)
                }
            }
        },
        pickFiles() {
            this.$refs.filesUpload.click();
        },
        onUploadFiles(e) {
            if(e.target.files) {
                let student_file = e.target.files[0]
                if(student_file) {
                    this.file = student_file
                }
            }
            if(e.dataTransfer) {
                let student_file = e.dataTransfer.files[0]
                if(student_file) {
                    this.file = student_file
                }
            }
        },
        async moveNext() {
            if(this.$route.query.type === 'member') {
                this.tab = 2
            }
            if(this.$route.query.type === 'corporate') {
                this.nextLoading = true

                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('lessonId', this.booking.lessonId)
                
                await this.$store.dispatch('getCorporate', this.getLoggedUser().id);
                const resp = await this.$store.dispatch('getTotalMembers', formData);
                
                this.nextLoading = false

                if(resp === 1) {
                    this.tab = 2
                }
            }
        },

        async setCalendar() {
            console.log(this.selectedCourse)
            if(this.selectedCourse && this.selectedCourse.Lessons.length) {
                this.calendarOptions.events = []
                this.events = []
                await this.selectedCourse.Lessons.forEach(item => {
                    const lessonStartDate = item.startDate.split('T')[0];
                    const today = this.getTodayDate();
                    item.isAvailable = ((lessonStartDate > today) && (item.availableSeats > (item.enrolledCount ?? 0)));
                    const event = {
                        id: item.id,
                        title: item.name,
                        start: lessonStartDate + 'T' + item.startTime,
                        end: item.endDate,
                        backgroundColor: (item.isAvailable) ? "#008001" : "#999999",
                        color: "white"
                    }
                    this.events.push(event)
                    this.calendarOptions.events = [...this.calendarOptions.events, event]
                }
            )}
            console.log(this.selectedCourse)
        },

        eventSelected(event) {
            this.booking.lessonId = event.event.id
            const selectedLesson = this.selectedCourse.Lessons.find(lesson => lesson.id === event.event.id) 
            if (selectedLesson) {
                if (selectedLesson.isAvailable) {
                    this.selectedLesson = selectedLesson;
                    let prevSelectedClass = document.getElementsByClassName("fc-selected-event-color");
                    for (let i = prevSelectedClass.length - 1; i >= 0; i--) {
                        prevSelectedClass[i].classList.remove("fc-selected-event-color");
                    }
                    event.el.classList.add("fc-selected-event-color");
                }
            }
        },

        getTodayDate(isGetStartOfMonth) {
            const today = new Date();
            const timeZoneOffset = today.getTimezoneOffset() * 60000;
            const todayIgnoreTimeZone = new Date(today - timeZoneOffset);
            todayIgnoreTimeZone.setUTCHours(0, 0, 0, 0);
            if (isGetStartOfMonth) {
                todayIgnoreTimeZone.setUTCDate(1);
            }
            return this.splitDate(todayIgnoreTimeZone.toISOString());
        },

        roundUpTo2Dec(val) {
            return (val.toFixed(2));
        },

        getTotalPriceForStripe() {
            let price = (this.getTotalPrice() + 2.35) / (1 - 0.034);
            return this.roundUpTo2Dec(price);
        },

        getTotalPriceForAlipay() {
            let price = (this.getTotalPrice()) / (1 - 0.01);
            return this.roundUpTo2Dec(price);
            return ;
        },

        getTotalPrice() {
            const user = this.getLoggedUser()
            if(user.type === 'corporate') {
                const totalMembers = this.getMemberCount
                const coursePrice = this.selectedCourse.price

                let totalPrice = (totalMembers * coursePrice) 

                let discountValue = this.getDiscount()

                if(user.discountType && user.discountType === 'per enrollment') {
                    const discounted = totalMembers * discountValue
                    totalPrice = totalPrice - discounted
                }

                if(user.discountType && user.discountType === 'per course') {
                    totalPrice = (totalMembers * discountValue)
                }

                return totalPrice
                
            }
            return this.selectedCourse.price
        },

        getDiscount() {
            const user = this.getLoggedUser()
            if(user.type === 'corporate') {

                const currentData = moment()
                var start = moment(this.getCorporate.discountStartDate, "YYYY-MM-DD");
                var end = moment(this.getCorporate.discountEndDate, "YYYY-MM-DD");

                //Difference in Current and Start Date
                const isValid = moment.duration(currentData.diff(start)).asDays();
                console.log('Days ', isValid)
                if(isValid > -1) {
                    const days = moment.duration(end.diff(start)).asDays();
                    if(days > 0) {
                        const course = this.getCorporate.corporatecourses.find(course => course.id === this.selectedCourse.id)
                        if(course) {
                            console.log(course.CorporateCourses.discountValue)
                            return course.CorporateCourses.discountValue
                        }
                    }
                }
            }
            return 0
        },

        getDiscountType() {
            const user = this.getLoggedUser()
            if(user.type === 'corporate') {
                return user.discountType ? user.discountType + ' - ' : ''
            }
            return ''
        },

        getPublicNote() {
            return ((this.$i18n.locale  === 'zh')
                ? (this.selectedLesson.chinesePublicNote ?? "")
                : (this.selectedLesson.publicNote ?? "")
                ).replace(/\n/g, '<br>');
        },

        async confirmBooking() {
            if (this.bookingLoading) {
                return
            }
            if ((!(this.booking.paymentMethod)) && (!(this.$route.query.type === 'corporate'))) {
                this.toast({message: "Please select payment.", title: "Create Bookings", type: "warning"})
                return;
            }
            if(!(this.acceptTerms)) {
                this.toast({message: "Please accept terms and conditions.", title: "Create Bookings", type: "warning"})
                return;
            }

            this.bookingLoading = true;
            let bookingData = Object.assign({}, this.booking)
            console.log(this.booking.lessonId)
            bookingData.date = moment().format("YYYY-MM-DD")

            if(this.$route.query.type === 'corporate') {
                bookingData.bookedAs = 'corporate'
                bookingData.bookedBy = 'corporate'
                bookingData.corporateId = this.getLoggedUser().id
                bookingData.file = this.file

                var form_data = new FormData();
                for ( var key in bookingData ) {
                    form_data.append(key, bookingData[key]);
                }

                const resp = await this.$store.dispatch('createCorporateBooking', form_data)

                if(resp === 1) {
                    this.$router.push({path: '/thankyou', query: {type: this.$route.query.type}})
                }

                this.bookingLoading = false
                return;
            }

            if(this.$route.query.type === 'member') {

                this.bookingPayload = null

                bookingData.bookedAs = 'individual member'
                bookingData.bookedBy = 'individual member'
                bookingData.memberId = this.getLoggedUser().id

                this.bookingPayload = Object.assign({}, bookingData)


                if(bookingData.paymentMethod === 'credit card') {
                    this.$refs.elementRef.submit();
                } else {
                    this.submitStudentBooking(this.bookingPayload)
                }
                return;
            }
            this.bookingLoading = false;
        },

        async submitStudentBooking(payload) {
            this.bookingLoading = true;
            const resp = await this.$store.dispatch('createMemberBooking', payload)
            if(resp === 1) {
                if (this.getRedirectUrl) {
                    window.open(this.getRedirectUrl, '_blank');
                    this.checkPaymentWithDelay(this.getTransactionId);
                }
                else {
                    this.$router.push({path: '/thankyou', query: {type: this.$route.query.type}})
                }
            }
            else{
                this.bookingLoading = false;
            }
        },

        tokenCreated(token) {
            if(token) {
                const charge = {
                    stripeToken: token,
                    amount: this.getTotalPriceForStripe()*100, // the amount you want to charge the customer in cents. $100 is 1000 (it is strongly recommended you use a product id and quantity and get calculate this on the backend to avoid people manipulating the cost)
                    username: this.getLoggedUser().lastName + ' ' + this.getLoggedUser().firstName // optional description that will show up on stripe when looking at payments
                }

                this.bookingPayload.charge = charge

                this.submitStudentBooking(this.bookingPayload)
                return;
            }
            this.bookingLoading = false;
        },

        checkPaymentWithDelay(transactionId) {
            let that = this;
            this.checkPaymentTimer = setTimeout(async function() {
                const resp = await that.$store.dispatch('checkAlipayPayment', {transactionId})
                if (resp === 1) {
                    if (that.getPaymentStatus) {
                        if (that.getPaymentStatus.paymentNotFound) {
                            that.bookingLoading = false;
                            that.toast({message: "Payment error. Please try again", title: "Payment", type: "warning"})
                            return;
                        }
                        else if (that.getPaymentStatus.isSettled) {
                            that.bookingLoading = false
                            that.$router.push({path: '/thankyou', query: {type: this.$route.query.type}})
                            return;
                        }
                    }
                }
                // Keep calling if cannot get payment status
                that.checkPaymentWithDelay(transactionId);
            }, 3000);

        },
    },
}
</script>

<style scoped>
.pick-file-area {
    border: 1px dashed #ddd !important;
    padding: 20px 0;
    border-radius: 7px;
}
.payment-reminder {
    font-size: 16px;
    color: red;
}
.stripe-reminder {
    font-size: 16px;
    float: right;
}
.tc-modal-padding {
    padding-left: 30px;
    padding-right: 30px;
}
.tc-modal ul {
    list-style-type: none;
    padding-left: 0;
}
.tc-modal ol {
    padding-left: 30px;
    text-align:  left;
}
.tc-modal li::marker {
    color: blue;
}
.tc-modal ol > li > p {
    color: blue;
}

</style>

<style>
.fc .fc-toolbar-title {
    font-size: 4vw;
}
.fc .fc-button {
    padding: 0.2em 0.1em;
}
@media screen and (min-width: 768px) {
    .fc .fc-toolbar-title {
        font-size: 1.75em;
    }
    .fc .fc-button {
        padding: 0.4em 0.65em;
    }
}

</style>